import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { getSuitableBuildingType } from '../../components/search_filters/filters/helpers';
import { TypeFilterNewbuilding } from '../../components/search_filters/filters/newbuilding_filter_ab';
import { TypeFilter as TypeFilterInput } from '../../components/search_filters/filters/type_filter';
import {
  AB_ALLOWED_SEARCH_TYPES,
  AB_ALLOWED_SECTIONS,
  getABNewbuildingSearchTabs,
} from '../../helpers/ab_newbuilding_search_tabs';
import { IBuildingTypesConfig } from '../../models/filters/building_types';
import { ISearchType, SearchType } from '../../models/filters/type';
import { ISearchConfig } from '../../models/search';
import { IStore } from '../../models/store';
import { updateBuildingType } from '../../redux/modules/search/building_types';
import { setDirty, setSearchType } from '../../redux/modules/search/type';
import { clearCommercialGeo } from '../../redux/modules/search/user_geo';
import { GenericFilter } from './generic_filter';

interface IStoreProps {
  type: ISearchType;
  abNewbuildingSearchTabs: boolean;
  buildingType: string[];
}

interface IDispatchProps {
  onClearCommercialGeo(): void;
  setDirty(isDirty: boolean): void;
  setSearchType(searchType: string): void;
  updateBuildingType(buildingType: string[]): void;
}

interface IOwnProps {
  buildingTypes: IBuildingTypesConfig;
  searchConfig: ISearchConfig;
}

interface IProps extends IStoreProps, IDispatchProps, IOwnProps {}

class TypeFilter extends GenericFilter<IProps> {
  protected setDirty(isDirty: boolean) {
    this.props.setDirty(isDirty);
  }

  public render() {
    const { abNewbuildingSearchTabs, type: {searchType, section = ''} } = this.props;
    // TODO Удалить TypeFilterNewbuilding после завершения эксперимента CD-41677
    if (
      abNewbuildingSearchTabs &&
      AB_ALLOWED_SEARCH_TYPES.includes(searchType) &&
      AB_ALLOWED_SECTIONS.includes(section)
    ) {
      return (
        <TypeFilterNewbuilding
          value={this.props.type.searchType}
          onChange={this.hendlerOnChange}
        />
      );
    } else {
      return (
        <TypeFilterInput
          value={this.props.type.searchType}
          onChange={this.hendlerOnChange}
        />
      );
    }
  }

  private hendlerOnChange = (type: string) => {
    const {
      setSearchType,
      onClearCommercialGeo,
      updateBuildingType,
      buildingType,
      buildingTypes,
      searchConfig,
    } = this.props;

    setSearchType(type);

    if (type === 'rent_short') {
      onClearCommercialGeo();
    }

    const suitableBuildingType = getSuitableBuildingType(type, buildingType, buildingTypes, searchConfig);

    updateBuildingType(suitableBuildingType);
  }
}

function mapStateToProps(state: IStore, props: IOwnProps): IStoreProps {
  return {
    abNewbuildingSearchTabs: getABNewbuildingSearchTabs(state.mainpage),
    type: state.type,
    buildingType: state.buildingType.buildingType,
  };
}

function mapDispatchToProps(dispatch: Dispatch, props: IOwnProps): IDispatchProps {
  return {
    onClearCommercialGeo: () => dispatch(clearCommercialGeo()),
    updateBuildingType: (buildingType: string[]) => dispatch(updateBuildingType(buildingType)),
    setDirty: (isDirty: boolean) => dispatch(setDirty(isDirty)),
    setSearchType: (searchType: SearchType) => dispatch(setSearchType(searchType)),
  };
}

const TypeFilterWrapper = connect<
  IStoreProps, IDispatchProps, IOwnProps
>(mapStateToProps, mapDispatchToProps)(TypeFilter as any);

export { TypeFilterWrapper as TypeFilter, TypeFilter as TypeFilterClass };
